import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as d3 from 'd3';
import PropTypes from 'prop-types';
import styles from './../../components/Chart/Chart.less';
import * as dashboardActions from './../../actions/dashboardActions';
import * as chartActions from './../../actions/chartActions';
import * as commonActions from './../../actions/commonActions';
import * as authActions from '../../redux/modules/auth';
import { connect } from 'react-redux';
import Chart from './../../components/Chart/LineChart';
import HistoricalLineChart from './../../components/Chart/HistoricalLineChart';
import MultiChart from './../../components/Chart/MultipleLineChart';
import CandleStickChart from './../../components/Chart/CandleStickChart';
import HistoricalCandleChart from './../../components/Chart/HistoricalCandleChart';
import OHLC from './../../components/Chart/OHLCChart';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
import Modal from 'react-modal';
import { utcSecond, utcMinute, utcHour, utcDay } from 'd3-time';
import i18next from 'i18next';
import { applyStyleapplyToHover, setDirection } from './../../utils/utils';
import HoverTable from './../../components/HoverTable/index.js';
import {DcoDropdown} from './../../components/UI/Dropdown/Dropdown';
import '../../theme/styles/calendar.css';
import DateSelector from '../DateSelector/DateSelector';
import { getSelectedDate, getFormattedDate } from '../../utils/utils'; //import
import {themes} from "../../theme/styles/themeJS";
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';

let flag = false;
let typeSelected = 'A';
let liveLineTime = new Date().valueOf();
let plotTime = liveLineTime-20000000;
let testArr = 0;

// const elementsData = [
//   {"classNames":"widgetheader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"vericalDotIcon", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   //{"classNames":styles.timehead1, "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   //{"classNames":styles.timehead, "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"chartDropdownMenuList", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"widgettitle", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"react-stockcharts-tooltip-label", "elementType":"normal", "applyTo":"all", "tagNames":"tspan"},
//   {"classNames":"", "elementType":"normal", "applyTo":"all", "tagNames":"tspan"},
//   {"classNames":"", "elementType":"tag", "applyTo":"all", "tagNames":"text","parent":"tick"},
//   {"classNames":"", "elementType":"tag", "applyTo":"all", "tagNames":"line","parent":"tick"},
//   {"classNames":"react-stockcharts-axis-domain", "elementType":"normal", "applyTo":"all", "tagNames":"path"},
//   {"classNames":"chartBody", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"widgetwrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"chrtDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"lblDropdown","elementType":"normal", "applyTo":"all", "tagNames":"label"},
//   {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"glyphicon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
//   {"classNames":"dropDownList","elementType":"tag", "applyTo":"all", "tagNames":"li"},
//   {"classNames":"chartLoading","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"resizeLayout","elementType":"normal", "applyTo":"all", "tagNames":"div"}
// ];
const directionData = [
  {"classNames":"widgettitle","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"vericalDotIcon","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"resizeLayout","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"chartDropdownMenu","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"chartDropdownMenuList", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"msgTitle","elementType":"normal", "applyTo":"all", "tagNames":"div"}
];
@connect(
  state => ({socketData: state.dashboardRoot.instrumentListReducer.socketData,
  liveLineChartData: state.dashboardRoot.chartReducer.lineChartValue,
  DataFlag: state.dashboardRoot.chartReducer.flag,
  nullMsg: state.dashboardRoot.chartReducer.message,
  status:state.dashboardRoot.instrumentListReducer.status,
  liveCandleStickChartData: state.dashboardRoot.chartReducer.CandleStickChartValue,
  isChartDataNull: state.dashboardRoot.chartReducer.isChartDataNull,
  historicalAPIData: state.dashboardRoot.chartReducer.historicalData,
  respQueryParamString: state.dashboardRoot.chartReducer.respQueryParamString,
  historicalRespQueryParamString: state.dashboardRoot.chartReducer.historicalRespQueryParamString,
  destinationUniqueId: state.dashboardRoot.chartReducer.destinationUniqueId,
  userDetail: state.auth.userDetail,
  check: state.dashboardRoot.instrumentListReducer.check,
  // cmdt:state.dashboardRoot.instrumentListReducer.cmdt,
  deleteWidgetKey: state.dashboardRoot.dashboardReducer.deleteWidgetKey,
  language:state.dashboardRoot.commonReducer.language,
  DCO:state.dashboardRoot.instrumentListReducer.DCO,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
  DFA: state.auth.DFA,
  navigationStatus:state.dashboardRoot.commonReducer.navigationStatus,
  openCalender: state.dashboardRoot.commonReducer.openCalender,
  widgetKeyValue:state.dashboardRoot.commonReducer.widgetKeyValue,
  layout: state.dashboardRoot.dashboardReducer.layout,
  loadTemplateChange: state.dashboardRoot.dashboardReducer.loadTemplateChange,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  apiFlag:state.dashboardRoot.instrumentListReducer.apiFlag,
  chartFlag: state.dashboardRoot.dashboardReducer.chartFlag,
}),
  {...chartActions, ...dashboardActions, ...commonActions, ...authActions})

export default class ChartComponent extends Component {

  static propTypes = {
    CloseIcon: PropTypes.object,
    keyValue: PropTypes.String,
    deleteWidget: PropTypes.func,
    //socketData: PropTypes.array,
    DFA: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
    lineChartData: PropTypes.func,
    candleChartData: PropTypes.func,
    liveLineChartData: PropTypes.array,
    DataFlag: PropTypes.number,
    status:PropTypes.string,
    nullMsg: PropTypes.string,
    liveCandleStickChartData: PropTypes.array,
    historicalChartData: PropTypes.func,
    historicalAPIData: PropTypes.array,
    userDetail:PropTypes.object,
    deleteWidgetKey: PropTypes.array,
    language:PropTypes.string,
    resizeChart: PropTypes.func,
    openCalender:PropTypes.boolean,
    onClickCalender:PropTypes.func,
    navigationStatus: PropTypes.string,
    changeChartCmdyPair: PropTypes.func,
    apiFlag: PropTypes.boolean,
    chartFlag: PropTypes.boolean,
    setApiFlag:PropTypes.func
  }

  state = {
    liveCategoryVal:0,
    timeSet:0,
    msg:'loading',
    histMsg:'loading',
    popupflag:false,
    timeFlag: 0,
    durationSelected: 'Minute',
    clickedRemove: false,
    CmdtPair:'',
    lineZoomSet: new Date().valueOf() - 600000,
    checkFlag: 0,
    CmdtPairId:'',
    cmdtPairOptions: [],
    dataTypeOptions: [
      { key: 'live', value: 'Live' },
      { key: 'historical', value: 'Historical' }
    ],
    historicalGraphTypeOptions: [
      { key: 'line', value: 'Line' },
      { key: 'ohlc', value: 'OHLC' },
      { key: 'candleStick', value: 'Candle Stick' }
    ],
    historicalDurationOptions: [
      { index: 1, value: 'Day' },
      { index: 2, value: 'Month' },
      { index: 3, value: 'Quarter' },
      { index: 4, value: 'Half Year' },
      { index: 5, value: 'Year' }
    ],
    liveGraphTypeOptions: [
      { key: 'line', value: 'Line' },
      { key: 'candleStick', value: 'Candle Stick' }
    ],
    liveCategoryOptionsBidAsk: [
      { key: 'bid', value: 'Bid', title: "Bid" },
      { key: 'ask', value: 'Ask', title: "Ask" },
      { key: 'both', value: 'Both', title: "Both" }
    ],
    liveCategoryOptionsSellBuy: [
      { key: 'bid', value:  'Bid', title: "sell" },
      { key: 'ask', value: 'Ask', title: "buy" },
      { key: 'both', value: 'Both', title: "Both" }
    ],
    liveDurationOptions: [
      { key: 'tick', value: 'Tick' },
      { key: 'minute', value: 'Minute' },
      { key: 'hour', value: 'Hour' },
    ],
    liveCategoryOptions:{},
    dataType: 'Live',
    dataTypeKey: 'live',
    historicalDuration: 'Day',
    //historicalEndDate: moment().subtract(1, 'days'),
    historicalGraphType: 'Line',
    historicalGraphTypeKey:'line',
    //historicalStartDate: moment().subtract(7, 'days'),
    liveCategory: 'Ask',
    liveCategoryKey:'ask',
    liveCategoryBuySellKey:'buy',
    liveDuration: 'Minute',
    liveDurationKey:'minute',
    liveGraphType: 'Candle Stick',
    liveGraphTypeKey:'candleStick',
    liveDurationIntervalValue: 0,
    liveCandleDurationInterval:30000,
    data: [],
    dataCandle: [],
    data2: [],
    chartDataFormatted: false,
    historicalDataFormatted: false,
    uniqueId: Math.floor(Math.random() * 0xFFFF),
    historicalData: [],
    deleteWidget: [],
    showFilters: true,
    lastLiveAPIQueryParams: '',
    pointsSinceLastAppend: [],
    pointsSinceLastAppendCandle: [],
    nextStateUpdateTime: '',
    nextStateUpdateTimeCandle: '',
    decimals: 2,
    isPopOutDisabled:false,
    menusOpen:false,
    showGridOptions:false,
    openCalender: false,
    id:'last7Days',
    validationFlag:false,
    currentDate: new Date().toLocaleDateString('en-US'),
    historicalStartDate:new Date(),
    historicalEndDate: new Date(),
  }

  constructor() {
    super();
    this.zoomLevel = undefined;
    this.CmdtPairChangeEvent = this.CmdtPairChangeEvent.bind(this);
    this.openMenus = this.openMenus.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.checkOpencalendar = this.checkOpencalendar.bind(this);
  }
  checkOpencalendar(){
    try{
      this.props.onClickCalender(false,this.props.keyValue)
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkOpencalendar', component:"ChartComponent"});
    }
  }
  componentWillMount() {
    this.setState({msg:'loading'});
    this.setState({histMsg:'loading'});
    let sDate = new Date();
    sDate.setDate(new Date().getDate() - 6);
    this.setState({historicalStartDate: sDate});
    this.setState({historicalEndDate: new Date()});
    //this.lineChartDataAPICallStateWrapper(0, this.state.CmdtPair, this.state.liveDuration,this.state.liveGraphType);
    //this.CandleStickChartDataAPICallStateWrapper(0, this.state.CmdtPair, this.state.liveDuration);
    let liveCategoryValue, liveCategoryKey ;
    if (this.props.userDetail.ShowBuySellInRates === true ) {
      if (this.props.userDetail.showPrice === 'ASK' || this.props.userDetail.showPrice === 'BOTH') {
        liveCategoryValue = 'buy';
        liveCategoryKey = 'ask';
      }else if (this.props.userDetail.showPrice === 'BID') {
        liveCategoryValue = 'sell';
        liveCategoryKey = 'bid';
      }
    }else {
      if (this.props.userDetail.showPrice === 'ASK' || this.props.userDetail.showPrice === 'BOTH') {
        liveCategoryValue = 'Ask';
        liveCategoryKey = 'ask';
      }else if (this.props.userDetail.showPrice === 'BID') {
        liveCategoryValue = 'Bid';
        liveCategoryKey = 'bid';
      }
    }
    // console.log("liveCategoryValue::"+liveCategoryValue);
    // console.log("liveCategoryKey::"+liveCategoryKey);
    this.setState({
      liveCategoryBuySellKey:liveCategoryValue,
      liveCategoryKey:liveCategoryKey,
      liveCategory:liveCategoryKey === 'ask' ? 'Ask' : 'Bid',
      liveCategoryOptions:this.props.userDetail.ShowBuySellInRates === true ? this.state.liveCategoryOptionsSellBuy:this.state.liveCategoryOptionsBidAsk
    });
    this.setState({showPrice:this.props.userDetail.showPrice});
    //this.setState({liveCategoryBuySellKey: this.props.userDetail.ShowBuySellInRates === true && this.state.liveCategory === 'Ask' ? 'buy' :this.props.userDetail.ShowBuySellInRates === true && this.state.liveCategory === 'Bid' ? 'sell':this.state.liveCategory});
}

  handleDateRange = (event, picker) => {
    try{
      // if(picker.startDate.format('YYYY/MM/DD') === picker.endDate.format('YYYY/MM/DD')) {
      //   this.setState({popupflag:true});
      // }
      var from =  new Date(picker.startDate.format('YYYY/MM/DD'));
      var to =  new Date(picker.endDate.format('YYYY/MM/DD'));
      if( ((to - from)/(1000*60*60*24)) < 6  ) {
        this.setState({popupflag:true});
      }
      else {
        this.setState({historicalStartDate: picker.startDate, historicalEndDate: picker.endDate});
        this.fetchHistoricalData();
      }
      this.zoomLevel = undefined;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleDateRange', component:"ChartComponent"});
    }
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    ////const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames":"vericalDotIcon"}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    this.setState({deleteWidget: this.props.deleteWidgetKey});
    this.setState({msg:'loading'});
    this.setState({histMsg:'loading'});
    const cmdtyPairOptionsLS = JSON.stringify(this.props.DCO);
    const socketDataLS = this.props.socketData;
    let cmdtyPairOptionsArray = [];
    socketDataLS.forEach((item, index) => {
      const cmdty = item.I;
      const cmdtyDes = item.ID;
      const temindex=cmdtyPairOptionsLS.indexOf((cmdty));
      let decimals=2;
      if((item.TR).toString().split(".")[1]){
       decimals = (item.TR).toString().split(".")[1].length;
     }
     else{
       decimals = 2;
     }
      if(temindex !== -1)
      {
        cmdtyPairOptionsArray.push({index:cmdtyPairOptionsArray.length, cmdtDesc: cmdtyDes, decimals: decimals, cmdtId:cmdty});
      }
    });
    this.setState({ cmdtPairOptions: cmdtyPairOptionsArray });
    this.setState({liveCategoryOptions:this.props.userDetail.ShowBuySellInRates === true ? this.state.liveCategoryOptionsSellBuy:this.state.liveCategoryOptionsBidAsk});
    // this.setState({CmdtPair: cmdtyPairOptionsArray[0].cmdtDesc});
    // this.setState({CmdtPairId: cmdtyPairOptionsArray[0].cmdtId});
    // this.setState({decimals: cmdtyPairOptionsArray[0].decimals});
    this.props.layout.map((item) => {
      if (item.i === this.props.keyValue) {
        cmdtyPairOptionsArray.map((i)=>{
          item.cmdtyPair=item.cmdtyPair===undefined?i.cmdtId:item.cmdtyPair;
          if(i.cmdtId===item.cmdtyPair){
            this.setState({CmdtPair: i.cmdtDesc});
            this.setState({CmdtPairId: i.cmdtId});
            this.setState({decimals: i.decimals});
            let dataType= this.state.dataType;
           let liveCategory =this.state.liveCategory;
            //console.log(" mount liveCategory:"+liveCategory);
           let liveDuration =this.state.liveDuration;
           let graphType = this.state.liveGraphType;
           let historicalGraphType= this.state.historicalGraphType;
           if(item.chartData){
               dataType= item.chartData[0].dataType;
               liveCategory =item.chartData[0].category;
               liveDuration =item.chartData[0].duration;
               graphType = item.chartData[0].graphType;
               historicalGraphType= item.chartData[0].histGraphType;
           }
           //console.log("did mount liveCategory:"+liveCategory);
           if(this.state.showPrice === "ASK" || this.state.showPrice === "BOTH"){
             if (item.chartData) {
               if (this.state.liveCategory === item.chartData[0].category) {
                 liveCategory = item.chartData[0].category;
               }else {
                 liveCategory = this.state.liveCategory
               }
             }else {
               liveCategory = liveCategory
             }
           }
           else{
             if (item.chartData) {
               if (this.state.liveCategory === item.chartData[0].category) {
                 liveCategory = item.chartData[0].category;
               }else {
                 liveCategory = this.state.liveCategory
               }
             }else {
               liveCategory = liveCategory
             }
           }
            //console.log("new liveCategory:"+liveCategory);
           if(dataType==='Live'){
             this.setState({dataTypeKey: 'live'});
           }else{
              this.setState({dataTypeKey: 'historical'});
           }
           if(liveDuration==='Tick'){
             this.setState({liveDurationKey: 'tick'});
           }else if(liveDuration==='Minute'){
             this.setState({liveDurationKey: 'minute'});
           }else{
             this.setState({liveDurationKey: 'hour'});
           }
           if(historicalGraphType==='Line'){
             this.setState({historicalGraphTypeKey: 'line'});
           }else if(historicalGraphType==='OHLC'){
              this.setState({historicalGraphTypeKey: 'ohlc'});
           }else{
             this.setState({historicalGraphTypeKey: 'candleStick'});
           }
           if(graphType==='Line'){
             this.setState({liveGraphTypeKey: 'line'});
           }else{
             this.setState({liveGraphTypeKey: 'candleStick'});
           }
           this.setState({dataType:dataType, liveCategory:liveCategory, liveDuration:liveDuration, liveGraphType:graphType,historicalGraphType:historicalGraphType})
           //this.setState({liveCategoryBuySellKey:this.props.userDetail.ShowBuySellInRates === true && liveCategory === 'Ask' ? 'buy' :this.props.userDetail.ShowBuySellInRates === true && liveCategory === 'Bid' ? 'sell':liveCategory});
           if(dataType ==='Live'){
             this.setState({dataTypeKey: 'live'});
             if (liveCategory === 'Bid') {
               this.setState({liveCategoryKey: 'bid'});
              // this.setState({liveCategoryBuySellKey:this.props.userDetail.ShowBuySellInRates ===  true ? "SELL":"Bid"});
               this.lineChartDataAPICallStateWrapper(1, i.cmdtId, i.cmdtDesc, liveDuration, graphType);
             } else if (liveCategory === 'Ask') {
               this.setState({liveCategoryKey:'ask'});
              // this.setState({liveCategoryBuySellKey:this.props.userDetail.ShowBuySellInRates ===  true ? "BUY":"Ask"});
               this.lineChartDataAPICallStateWrapper(0, i.cmdtId, i.cmdtDesc, liveDuration, graphType);
             } else {
               this.setState({liveCategoryKey: 'both'});
             // this.setState({liveCategoryBuySellKey:"both"});
               if(graphType === 'Candle Stick'){
                 this.lineChartDataAPICallStateWrapper(0, i.cmdtId, i.cmdtDesc, liveDuration, graphType);
               }
               else {
                 this.lineChartDataAPICallStateWrapper(2, i.cmdtId, i.cmdtDesc, liveDuration, graphType);
               }
             }
           }else {
             this.setState({dataTypeKey: 'historical'});
             this.historicalChartDataAPICallStateWrapper(i.cmdtId, i.cmdtDesc, this.state.historicalStartDate, this.state.historicalEndDate, this.state.uniqueId);
           }
            // this.lineChartDataAPICallStateWrapper(0, i.cmdtDesc, this.state.liveDuration, this.state.liveGraphType);
          }
        })
      }
    })
    this.props.setApiFlag(true);
    testArr = 1;
    //localStorage.setItem("selectedCmdty",cmdtyPairOptionsArray[0].cmdtDesc);
  }
  // to update chart with socket data
  componentWillReceiveProps(nextprops,nextstate) {
    if (this.state.showPrice !== nextprops.userDetail.showPrice) {
      // console.log("this.state.showPrice:"+this.state.showPrice);
      // console.log("nextprops.userDetail.showPrice:"+nextprops.userDetail.showPrice);
      this.setState({showPrice:nextprops.userDetail.showPrice});
      this.handleLiveCategoryOptionVal(nextprops.userDetail.showPrice,this.state.CmdtPair, this.state.CmdtPairId,this.state.dataType);
    }
    if (nextprops.apiFlag !== this.props.apiFlag && (this.state.dataType === 'Live')) {
        if (nextprops.chartFlag === true) {
          this.lineChartDataAPICallStateWrapper(this.state.liveCategoryVal, this.state.CmdtPairId, this.state.CmdtPair, this.state.liveDuration, this.state.liveGraphType);
        }
    }
    if (this.props.selectedLang !== nextprops.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextprops.selectedLang);
    }
    let m = new Date().getMinutes();
    // if(this.props.selectedCssColorTheme !== nextprops.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextprops.selectedCssColorTheme;
    //   //applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //     {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
    //     {"elmToHover":thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames":"vericalDotIcon"}
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // }
    if(nextprops.navigationStatus !== this.props.navigationStatus){
        this.props.onClickCalender(false,this.props.keyValue);
    }
    if(this.props.keyValue === nextprops.widgetKeyValue){
        this.setState({openCalender:nextprops.openCalender });
    }
    if(this.props.loadTemplateChange!==nextprops.loadTemplateChange){
      //console.log("inside layout change");
      nextprops.layout.map((item) => {
        if (item.i === this.props.keyValue) {
          this.state.cmdtPairOptions.map((i)=>{
            item.cmdtyPair=item.cmdtyPair===undefined?i.cmdtId:item.cmdtyPair;
            if(i.cmdtId===item.cmdtyPair){
              this.setState({CmdtPair: i.cmdtDesc});
              this.setState({CmdtPairId: i.cmdtId});
              this.setState({decimals: i.decimals});
              let dataType= 'Live';
              let liveCategory ='Ask';
              let liveDuration ='Minute';
              let graphType = 'Line';
              let historicalGraphType='Line';
              if(item.chartData){
                 dataType= item.chartData[0].dataType;
                 liveCategory =item.chartData[0].category;
                 liveDuration =item.chartData[0].duration;
                 graphType = item.chartData[0].graphType;
                 historicalGraphType= item.chartData[0].histGraphType;
              }

               if(dataType==='Live'){
                 this.setState({dataTypeKey: 'live'});
               }else{
                  this.setState({dataTypeKey: 'historical'});
               }

               if(liveDuration==='Tick'){
                 this.setState({liveDurationKey: 'tick'});
               }else if(liveDuration==='Minute'){
                 this.setState({liveDurationKey: 'minute'});
               }else{
                 this.setState({liveDurationKey: 'hour'});
               }

               if(historicalGraphType==='Line'){
                 this.setState({historicalGraphTypeKey: 'line'});
               }else if(historicalGraphType==='OHLC'){
                  this.setState({historicalGraphTypeKey: 'ohlc'});
               }else{
                 this.setState({historicalGraphTypeKey: 'candleStick'});
               }

               if(graphType==='Line'){
                 this.setState({liveGraphTypeKey: 'line'});
               }else{
                 this.setState({liveGraphTypeKey: 'candleStick'});
               }

               this.setState({dataType:dataType, liveCategory:liveCategory, liveDuration:liveDuration, liveGraphType:graphType,historicalGraphType:historicalGraphType})
               this.setState({liveCategoryBuySellKey:this.props.userDetail.ShowBuySellInRates === true && liveCategory === 'Ask' ? 'buy' :this.props.userDetail.ShowBuySellInRates === true && liveCategory === 'Bid' ? 'sell':liveCategory})

               if(dataType ==='Live'){
                 this.setState({dataTypeKey: 'live'});
                 if (liveCategory === 'Bid') {
                   this.setState({liveCategoryKey: 'bid'});
                  // this.setState({liveCategoryBuySellKey:this.props.userDetail.ShowBuySellInRates ===  true ? "SELL":"Bid"});
                   this.lineChartDataAPICallStateWrapper(1, i.cmdtId, i.cmdtDesc, liveDuration, graphType);
                 } else if (liveCategory === 'Ask') {
                   this.setState({liveCategoryKey: 'ask'});
                 //  this.setState({liveCategoryBuySellKey:this.props.userDetail.ShowBuySellInRates ===  true ? "BUY":"Ask"});
                   this.lineChartDataAPICallStateWrapper(0, i.cmdtId, i.cmdtDesc, liveDuration, graphType);
                 } else {
                   this.setState({liveCategoryKey: 'both'});
                 //  this.setState({liveCategoryBuySellKey:"both"});
                   if(graphType === 'Candle Stick'){
                     this.lineChartDataAPICallStateWrapper(0, i.cmdtId,  i.cmdtDesc, liveDuration, graphType);
                   }
                   else {
                     this.lineChartDataAPICallStateWrapper(2, i.cmdtId, i.cmdtDesc, liveDuration, graphType);
                   }
                 }
               }else {
                 this.setState({dataTypeKey: 'historical'});
                 this.historicalChartDataAPICallStateWrapper(i.cmdtId, i.cmdtDesc, this.state.historicalStartDate, this.state.historicalEndDate, this.state.uniqueId);
               }
              // this.lineChartDataAPICallStateWrapper(0, i.cmdtDesc, this.state.liveDuration, this.state.liveGraphType);
            }
          })
        }
      })
    }

    // if(this.props.language !== nextprops.language){
    //   this.setState({dataType: 'Live'});
    // }
    let s = new Date().getSeconds();
    liveLineTime = new Date().valueOf();
    if ((s > 25 && s < 30) || (s > 55)) {
      this.setState({checkFlag: 1});
    }
    if (this.state.durationSelected === 'Minute') {
      this.setState({lineZoomSet: liveLineTime - 600000});
    }
    if(this.state.durationSelected === 'Tick') {
      this.setState({lineZoomSet: liveLineTime - 240000});
    }
    // if(this.state.durationSelected === 'Hour') {
    //   setInterval(this.setTime.bind(this), 30000);
    // }
    // if(this.state.durationSelected === 'Hour') {
    //   if (m>this.state.timeSet) {
    //     if ((m-this.state.timeSet)>10) {
    //       console.log("success");
    //       this.setState({timeSet:m});
    //       this.setState({lineZoomSet: liveLineTime - 20000000});
    //     }
    //   }
    // else {
    //
    // }
    //}
    if(this.state.deleteWidget !== nextprops.deleteWidgetKey){
           this.setState({clickedRemove: false});
           this.setState({deleteWidget: nextprops.deleteWidgetKey});
    }
    // === Historical Data ===
    let historicalDataValue = cloneDeep(nextprops.historicalAPIData || []);
    // if (nextprops.destinationUniqueId === this.state.uniqueId && this.state.lastHistoricalAPIQueryParams === nextprops.historicalRespQueryParamString && !this.state.historicalDataFormatted && (historicalDataValue && historicalDataValue.length > 0 || nextprops.isChartDataNull)) {
    //   this.setState({ historicalData: [...historicalDataValue], historicalDataFormatted: true, lastHistoricalAPIQueryParams: '' });
    //   if(historicalDataValue.length < 2){
    //     this.setState({histMsg:'noDataAvlMsg'});
    //   }
    // }
    if (nextprops.destinationUniqueId !== this.props.destinationUniqueId) {
        this.setState({ historicalData: [...historicalDataValue], historicalDataFormatted: true, lastHistoricalAPIQueryParams: '' });
        if(historicalDataValue.length < 2){
            this.setState({histMsg:'noDataAvlMsg'});
        }
    }
    if(nextprops.DataFlag == 1){
      this.setState({histMsg:nextprops.nullMsg});
    }
    // === Live Data ===
    // Deep copy using lodash clone deep
    //let cmdtPairSocketValue = cloneDeep(nextprops.socketData.Data.filter(item => item.cmdty === this.state.CmdtPair)[0]) || {};

    let cmdtPairSocketValue = cloneDeep(nextprops.socketData.get(this.state.CmdtPairId)) || {};
    let pastChartData = [];
    let pastChartDataCandle = [];
    if (this.state.liveGraphType === 'Candle Stick') {
      if(nextprops.liveCandleStickChartData !== this.props.liveCandleStickChartData){
        pastChartDataCandle = cloneDeep(nextprops.liveCandleStickChartData);
      }
      }
      else {
        if(nextprops.liveLineChartData !== this.props.liveLineChartData){
         pastChartData = cloneDeep(nextprops.liveLineChartData);
        }
      }
      const type = this.state.liveCategory.toLowerCase();
      if (((this.state.liveGraphType === 'Line' && pastChartData && pastChartData.length > 0)) || ((this.state.liveGraphType === 'Candle Stick' && pastChartDataCandle && pastChartDataCandle.length > 0))) {   //if api data is present
      //  console.log("this.state.lastLiveAPIQueryParams "+ this.state.lastLiveAPIQueryParams +"  nextprops.respQueryParamString "+  nextprops.respQueryParamString);

      if (this.state.lastLiveAPIQueryParams === nextprops.respQueryParamString) {

        // API Response Data formatting
        let leftBorderDate = new Date().valueOf();
        // Based on selected filter value for Live Duration, leftBorderDate object is initialised.
        switch(this.state.liveDuration) {
        case 'Tick':
          // 10 mins
          leftBorderDate -= new Date().setHours(0, 0, 0, 0).valueOf();
          break;
        case 'Minute':
          // 10 min
          leftBorderDate -= new Date().setHours(0, 0, 0, 0).valueOf();
          break;
        case 'Hour':
          // Midnight today
          leftBorderDate = new Date().setHours(0, 0, 0, 0).valueOf();
          break;
        default:
          leftBorderDate -= new Date().setHours(0, 0, 0, 0).valueOf();
        };

        let high = parseFloat(cmdtPairSocketValue['H']) || '';
        let low = parseFloat(cmdtPairSocketValue['L']) || '';
        if (this.state.liveGraphType === 'Candle Stick') {
          leftBorderDate = new Date().setHours(0, 0, 0, 0).valueOf();
          pastChartDataCandle.slice().reverse().forEach((item, index, object) => {
            if (item['TS'] < leftBorderDate) {
              // Removes from API data, all points older than (time now - leftBorderDate) to reduce the total span of graph
              pastChartDataCandle.splice(object.length - 1 - index, 1);
            } else {
              //if(this.state.liveCategory=== 'Ask'){
                item['date'] = new Date(item['TS']);
                item['high'] = parseFloat(item['HM']);
                item['low'] = parseFloat(item['LM']);
                item['ask'] = parseFloat(item['OM']);
                item['bid'] = parseFloat(item['CM']);
                item['open'] = item.ask;
                item['close'] = item.bid;
              // Handles the case where Invalid Date error is encountered.
              if ( Object.prototype.toString.call(item['date']) === "[object Date]" ) {
                // it is a date
                if ( isNaN( item['date'].getTime() ) ) {
                  // invalid date
                  pastChartDataCandle.splice(object.length - 1 - index, 1);
                }
              }
            }
          });

        } else {

          if (type !== 'both') {
            pastChartData.slice().reverse().forEach((item, index, object) => {
              if (item['E'] < leftBorderDate) {
                // Removes from API data, all points older than (time now - leftBorderDate) to reduce the total span of graph
                pastChartData.splice(object.length - 1 - index, 1);
              } else {
                  item['date'] = new Date(item['E']);
                  item['Price'] = parseFloat(item[typeSelected]);
                  item['high'] = high;
                  item['low'] = low;
                // Handles the case where Invalid Date error is encountered.
                if ( Object.prototype.toString.call(item['date']) === "[object Date]" ) {
                  // it is a date
                  if ( isNaN( item['date'].getTime() ) ) {
                    // invalid date
                    pastChartData.splice(object.length - 1 - index, 1);
                  }
                }
              }
            });
          }
          else {
              pastChartData.slice().reverse().forEach((item, index, object) => {
                if (item['key'] < leftBorderDate) {
                  // Removes from API data, all points older than (time now - leftBorderDate) to reduce the total span of graph
                  pastChartData.splice(object.length - 1 - index, 1);
                } else {
                  item['date'] = new Date(item['E']);
                  item['high'] = parseFloat(item['A']);
                  item['low'] = parseFloat(item['B']);
                  item['ask'] = parseFloat(item['A']);
                  item['bid'] = parseFloat(item['B']);

                  // Handles the case where Invalid Date error is encountered.
                  if ( Object.prototype.toString.call(item['date']) === "[object Date]" ) {
                    // it is a date
                    if ( isNaN( item['date'].getTime() ) ) {
                      // invalid date
                      pastChartData.splice(object.length - 1 - index, 1);
                    }
                  }
                }
              });
          }
        }

        if (pastChartData.length < 2 && nextprops.status !== 0) {
          this.setState({msg:'noRatesAvailMsg'});
        }
        if (pastChartDataCandle.length < 2 && nextprops.status !== 0) {
          this.setState({msg:'noRatesAvailMsg'});
        }

        let lastObject = pastChartData[pastChartData.length-1] || {};
        let lastObjectCandle = pastChartDataCandle[pastChartDataCandle.length-1] || {};
        lastObject.D = lastObject && lastObject.date? lastObject.date.toISOString() : new Date().toISOString();
        lastObjectCandle.D = lastObjectCandle && lastObjectCandle.date? lastObjectCandle.date.toISOString() : new Date().toISOString();
        // nextStateUpdateTime is the time at which next set of points will be added to graph
        let newNextStateUpdateTimeCandle = lastObjectCandle.key + this.state.liveCandleDurationInterval;
        if (this.state.liveGraphType === 'Candle Stick') {
          if ((new Date().getMinutes() - new Date(lastObjectCandle.key).getMinutes()) >0 || (new Date().getSeconds() - new Date(lastObjectCandle.key).getSeconds()) >= 30) {
            if (new Date().getSeconds() < 30) {
              newNextStateUpdateTimeCandle = new Date().setSeconds(30);
            }
            else {
              newNextStateUpdateTimeCandle = new Date().setSeconds(0);
              newNextStateUpdateTimeCandle = new Date(newNextStateUpdateTimeCandle).setMinutes(new Date().getMinutes()+1);
            }
          }
        }
        let newNextStateUpdateTime = lastObject.key + this.state.liveDurationIntervalValue;

        if(!newNextStateUpdateTime) {
          newNextStateUpdateTime = new Date().valueOf();
        }
        // if (!newNextStateUpdateTimeCandle) {
        //   newNextStateUpdateTimeCandle = new Date().valueOf();
        // }
        if (parseFloat(cmdtPairSocketValue['H']) == 0 && parseFloat(cmdtPairSocketValue['L']) == 0 && nextprops.status === 0 ) {
          this.setState({msg:'noRatesAvailMsg'});
        }
        // Array emptied
        this.setState(prevState => ({ chartDataFormatted: true, pointsSinceLastAppend: [], pointsSinceLastAppendCandle: [], dataCandle: [...pastChartDataCandle], data: [...pastChartData], lastLiveAPIQueryParams: '', nextStateUpdateTime: newNextStateUpdateTime, nextStateUpdateTimeCandle: newNextStateUpdateTimeCandle }));
      }
    } else {
      // Socket Response Data formatting
      // Considers the socket point only when a graph is present, API data has been received.
      if (parseFloat(cmdtPairSocketValue['H']) == 0 && parseFloat(cmdtPairSocketValue['L']) == 0 ) {
        this.setState({msg:'noRatesAvailMsg'});
      }
      if (nextprops.status === 1 || nextprops.status === 2) {
        this.setState({msg:'noRatesAvailMsg'});
      }
      const socketObjectDate = new Date(cmdtPairSocketValue['RT']);
      // Handles the case where Invalid Date error is encountered.
      if ( Object.prototype.toString.call(new Date(socketObjectDate)) === "[object Date]" ) {
        // it is a date
            if ( isNaN( new Date(socketObjectDate).getTime() ) ) {
          // invalid date
          return;
        }
        cmdtPairSocketValue['date'] = socketObjectDate;
      }
      let mins = new Date().getMinutes();
      let secs = new Date().getSeconds();
      let current = new Date().valueOf();
      const pointsSinceLastAppend = this.state.pointsSinceLastAppend;
      const pointsSinceLastAppendCandle = this.state.pointsSinceLastAppendCandle;
      const nextStateUpdateTime = this.state.nextStateUpdateTime ? this.state.nextStateUpdateTime : new Date().valueOf();
      const nextStateUpdateTimeCandle = this.state.nextStateUpdateTimeCandle ? this.state.nextStateUpdateTimeCandle : current;
      //Checks if socket point has passed nextStateUpdateTime
      let candleTimeUpdate = nextStateUpdateTimeCandle;
      if((new Date(nextStateUpdateTimeCandle).getMinutes() <= new Date().getMinutes()) && (new Date().getSeconds() >= 0)) {
            if (secs === 0 || secs === 30) {
              this.setState({timeFlag: 1});
              candleTimeUpdate = new Date().valueOf();
            }
        }
      if (secs === 30) {
        if ((new Date(candleTimeUpdate).getMinutes() - mins === 1)) {
          return;
        }
        else {
          this.setState({timeFlag: 1});
          candleTimeUpdate = new Date().valueOf();
        }
      }
      else if(secs === 0) {
        if ((new Date(candleTimeUpdate).getSeconds() - secs <=30) && (new Date(candleTimeUpdate).getMinutes() - mins === 0)) {
          return;
        }
        else {
          this.setState({timeFlag: 1});
          candleTimeUpdate = new Date().valueOf();
        }
      }
      if ((this.state.liveGraphType === 'Line' && (parseFloat(cmdtPairSocketValue['H']) !== 0 && parseFloat(cmdtPairSocketValue['L']) !== 0 ) &&
      pointsSinceLastAppend.length > 0) ||
      (this.state.liveGraphType === 'Candle Stick' && (parseFloat(cmdtPairSocketValue['H']) !== 0 && parseFloat(cmdtPairSocketValue['L']) !== 0 ) && pointsSinceLastAppendCandle.length > 0)) {
        // Computes the array indices for bid & ask, sorted in desc order
        const sortDescByBid = d3.entries(pointsSinceLastAppend).sort(function(a,b) {return d3.descending(a.bid, b.bid);});
        const sortDescByBidLength = sortDescByBid.length;

        const sortDescByAsk = d3.entries(pointsSinceLastAppend).sort(function(a,b) {return d3.descending(a.ask, b.ask);});
        const sortDescByAskLength = sortDescByAsk.length;

        const sortDescByBidCandle = d3.entries(pointsSinceLastAppendCandle).sort(function(a,b) {return d3.descending(a.bid, b.bid);});
        const sortDescByBidLengthCandle = sortDescByBidCandle.length;

        const sortDescByAskCandle = d3.entries(pointsSinceLastAppendCandle).sort(function(a,b) {return d3.descending(a.ask, b.ask);});
        const sortDescByAskLengthCandle = sortDescByAskCandle.length;

        let iterator = 0;
        let iteratorCandle = 0;
        let pointsIndexArray = [];
        let pointsIndexArrayCandle = [];

          /* Filters out atleast 10 points out of all points obtained from Socket till 'nextStateUpdateTime'
             The logic is to find out, atleast one unique point where the Ask, Bid values are highest and lowest
             However, in most cases these values may lead to the same point, which was why atleast 10 such points are selected
             It is expected that atleast 3 unique graph points can be extracted with this logic per interval
          */
          while(pointsIndexArray.length <= 10 && pointsIndexArray.length !== sortDescByBidLength) {
            pointsIndexArray = [
              ...pointsIndexArray,
              ...new Set([
              // max ask index
              sortDescByAsk[iterator].key,
              // min ask index
              sortDescByAsk[sortDescByAskLength - (iterator + 1)].key,
              // max bid index
              sortDescByBid[iterator].key,
              // min bid index
              sortDescByBid[sortDescByBidLength - (iterator + 1)].key
            ])];
            iterator+=1;
          }
          while(pointsIndexArrayCandle.length <= 10 && pointsIndexArrayCandle.length !== sortDescByBidLengthCandle) {
            pointsIndexArrayCandle = [
              ...pointsIndexArrayCandle,
              ...new Set([
              // max ask index
              sortDescByAskCandle[iteratorCandle].key,
              // min ask index
              sortDescByAskCandle[sortDescByAskLengthCandle - (iteratorCandle + 1)].key,
              // max bid index
              sortDescByBidCandle[iteratorCandle].key,
              // min bid index
              sortDescByBidCandle[sortDescByBidLengthCandle - (iteratorCandle + 1)].key
            ])];
            iteratorCandle+=1;
          }
          let pointsToBeInserted = [];
          let pointsToBeInsertedCandle = [];
          // Points are fetched on the basis of already calculated indices
          pointsIndexArray.forEach(index => {
            pointsToBeInserted.push(pointsSinceLastAppend[index]);
          });
          pointsIndexArrayCandle.forEach(index => {
            pointsToBeInsertedCandle.push(pointsSinceLastAppendCandle[index]);
          });
          // Points are sorted chronologically
          pointsToBeInserted = pointsToBeInserted.sort((a,b) => {
            let x = a.date, y = b.date;
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
          });
          if (pointsToBeInserted.length> 1) {
            pointsToBeInserted  = pointsToBeInserted.splice(pointsToBeInserted[0], pointsToBeInserted[pointsToBeInserted.length-1]);
          }
          pointsToBeInsertedCandle = pointsToBeInsertedCandle.sort((a,b) => {
            let x = a.date, y = b.date;
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
          });
          if(this.state.liveGraphType === 'Candle Stick'){
            if(pointsToBeInsertedCandle.length > 1) {
              pointsToBeInsertedCandle.splice(pointsToBeInsertedCandle[0],pointsToBeInsertedCandle.length-1);
            }
            pointsToBeInsertedCandle[0].date = new Date(candleTimeUpdate);
          }
            let newNextStateUpdateTime = pointsSinceLastAppend[pointsSinceLastAppend.length - 1].date.valueOf() + this.state.liveDurationIntervalValue;
            let  newNextStateUpdateTimecandle = candleTimeUpdate + this.state.liveCandleDurationInterval;
            if(this.state.timeFlag === 1 && this.state.liveGraphType === 'Candle Stick') {
                this.setState(prevState => ({
                    dataCandle: [
                      ...prevState.dataCandle,
                      ...pointsToBeInsertedCandle
                    ],
                    // Array emptied
                    pointsSinceLastAppendCandle: [],
                    checkFlag: 0,
                    timeFlag: 0,
                    nextStateUpdateTimeCandle: newNextStateUpdateTimecandle
                }));
                flag = true;
                //applyStyle(thisComponent, allCssStyleRules, elementsData);
          }else if (this.state.liveGraphType === 'Line') {
                this.setState(prevState => ({
                    data: [
                      ...prevState.data,
                      ...pointsToBeInserted
                    ],
                    // Array emptied
                    pointsSinceLastAppend: [],
                    nextStateUpdateTime: newNextStateUpdateTime
                }));
                //applyStyle(thisComponent, allCssStyleRules, elementsData);
          }
              let pointtobeInsert=[];
              pointtobeInsert[0]=pointsToBeInsertedCandle[pointsToBeInsertedCandle.length-1];
              this.setState(prevState => ({
                  data2: [
                    ...pointtobeInsert
                  ]
              }));
              //applyStyle(thisComponent, allCssStyleRules, elementsData);
        }
        // If socket point has not yet passed nextStateUpdateTime
        let tempObj = {};
        let tempObjCandle = {};
                //if (this.state.liveGraphType === 'Candle Stick') {
                  let rate=((parseFloat(cmdtPairSocketValue['ask'])+parseFloat(cmdtPairSocketValue['bid']))/2);
                  if (nextprops.status === 0) {
                  if(!flag && pointsSinceLastAppendCandle.length>0){

                    let prevObj=this.state.pointsSinceLastAppendCandle[pointsSinceLastAppendCandle.length-1];
                    tempObjCandle.open = prevObj.open;
                    tempObjCandle.low = rate;
                    tempObjCandle.high = rate;
                    if(prevObj.high>rate){
                        tempObjCandle.high=prevObj.high;
                    }
                    if(prevObj.low<rate){
                        tempObjCandle.low=prevObj.low;
                    }
                  }else{
                    tempObjCandle.open = rate;
                    tempObjCandle.high = rate;
                    tempObjCandle.low = rate;
                  }
                  flag = false;
                  tempObjCandle.close = rate;
                  tempObjCandle.ask = tempObjCandle.open;
                  tempObjCandle.bid = tempObjCandle.close;
                  tempObjCandle.open = tempObjCandle.ask;
                  tempObjCandle.close = tempObjCandle.bid;
                  tempObjCandle.date = nextStateUpdateTimeCandle;
                //} else {
                  if (type !== 'both') {
                    tempObj.Price = parseFloat(cmdtPairSocketValue[type]);
                    tempObj.date = cmdtPairSocketValue['date'];
                    tempObj.high = parseFloat(cmdtPairSocketValue['H']) || '';
                    tempObj.low = parseFloat(cmdtPairSocketValue['L']) || '';
                  } else if (type === 'both'){
                    tempObj.ask = parseFloat(cmdtPairSocketValue['ask']);
                    tempObj.bid = parseFloat(cmdtPairSocketValue['bid']);
                    tempObj.date = cmdtPairSocketValue['date'];
                    tempObj.high = parseFloat(cmdtPairSocketValue['H']) || '';
                    tempObj.low = parseFloat(cmdtPairSocketValue['L']) || '';
                  }
               }

        // Edge case when Socket prop races ahead of API prop, resulting in undefined values for tempObj
        if (!tempObj.low || !tempObj.high) {
          return;
        }
        if (!tempObjCandle.low || !tempObjCandle.high) {
          return;
        }
        // Push socket point to array
        this.setState(prevState => ({
          pointsSinceLastAppend: [
            ...prevState.pointsSinceLastAppend,
            tempObj
          ],
          pointsSinceLastAppendCandle: [
            ...prevState.pointsSinceLastAppendCandle,
            tempObjCandle
          ]
        }));
      }
    //}
  }
  shouldComponentUpdate(nextprops, nextstate) {
    if (nextprops.apiFlag !== this.props.apiFlag) {
      return true;
    }
    if (nextprops.chartFlag !== this.props.chartFlag) {
      return true;
    }
    if(nextprops.widgetKeyValue !== this.props.widgetKeyValue){
      return true;
    }
    if(nextprops.deleteWidgetKey !== this.props.deleteWidgetKey){
          return true;
    }
    if (this.state.liveduration !== nextstate.liveDuration) {
          return true;
    }
    if (this.state.lineZoomSet !== nextstate.lineZoomSet) {
          return true;
    }
    if (this.props.isChartDataNull !== nextprops.isChartDataNull) {
          return true;
    }
    if (this.state.checkFlag !== nextstate.checkFlag) {
          return true;
    }
    if(this.state.deleteWidget !== nextstate.deleteWidget){
          return true;
    }
    // Update for resize
    if(nextprops.check !== this.props.check){
      // if(this.state.CmdtPairId === nextprops.cmdt){
      //        return true;
      // }
      if(this.props.socketData.get(nextstate.CmdtPairId) !== nextprops.socketData.get(nextstate.CmdtPairId)){
             return true;
      }
    }
    if (this.state.msg !== nextstate.msg) {
      return true;
    }
    if(nextprops.status !== this.props.status){
      return true;
    }
    if(nextprops.DataFlag !== this.props.DataFlag){
      return true;
    }
    if( this.state.popupflag !== nextstate.popupflag){
      return true;
    }
    if ( this.props.width !== nextprops.width ){
      return true;
    }
    if (this.props.height !== nextprops.height) {
      return true;
    }
    if(this.state.clickedRemove !== nextstate.clickedRemove){
      return true;
    }
    if(this.state.isPopOutDisabled !== nextstate.isPopOutDisabled){
      return true;
    }
    if(nextprops.userDetail.fontSize !== this.props.userDetail.fontSize){
      return true;
    }
    if(nextstate.menusOpen !== this.state.menusOpen){
      return true;
    }
    if(nextprops.navigationStatus !== this.props.navigationStatus){
     return true;
    }
    if(nextprops.openCalender !== this.props.openCalender){
      return true;
    }
    if(nextprops.validationFlag !== this.props.validationFlag){
      return true;
    }
    if(this.state.historicalStartDate !== nextstate.historicalStartDate){
      return true;
    }
    if(this.state.historicalEndDate !== nextstate.historicalEndDate){
      return true;
    }
    if(this.state.id !== nextstate.id){
      return true;
    }
    if(this.state.openCalender !== nextstate.openCalender){
      return true;
    }
    if(this.state.currentDate !== nextstate.currentDate){
      return true;
    }
    // Update if data changed by api.
    // let historicalDataValue = cloneDeep(nextprops.historicalAPIData || []);
    // if (nextprops.destinationUniqueId === this.state.uniqueId &&
    //     this.state.lastHistoricalAPIQueryParams === nextprops.historicalRespQueryParamString &&
    //     !this.state.historicalDataFormatted &&
    //     (historicalDataValue && historicalDataValue.length > 0 || nextprops.isChartDataNull)) {
    //   return true;
    // }
    if (nextprops.destinationUniqueId !== this.state.uniqueId) return true
    // Update if caused by changing filters.
    if(this.isFitersChanged(this.state,nextstate)) {
      return true;
    }
    // Do not update if caused by the socket tick but not yet have enough points to render.
  }

  isFitersChanged(state, nextstate) {
    try{
      let filters = [
        'CmdtPair',
        'dataType',
        'historicalDuration',
        'historicalEndDate',
        'historicalGraphType',
        'historicalStartDate',
        'liveCategory',
        'liveDuration',
        'showFilters',
        'liveGraphType'
      ];
      for (let i = 0; i < filters.length; ++i){
        if(state[filters[i]]!==nextstate[filters[i]]) {
          return true;
        }
      }
      return false;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'isFitersChanged', component:"ChartComponent"});
    }
  }

  CmdtPairChangeEvent = (text,cmdtyKey) => {
    try{
    // Change in comodity pair
    //this.setState({msg:'Loading...'});
    let template=[{'dataType':this.state.dataType,'graphType':this.state.liveGraphType,
                   'category':this.state.liveCategory,'duration':this.state.liveDuration,
                   'histGraphType':this.state.historicalGraphType}];
    this.props.changeChartCmdyPair(text,this.props.keyValue,this.props.layout,template);
    this.props.layoutChanged(1);
    this.setState({histMsg:'loading'});
    let newCmdtyPair = text;
    let decimals = this.state.cmdtPairOptions.filter((item) => {
      return item.cmdtDesc === cmdtyKey
    })[0].decimals;
    this.setState({ decimals: decimals });
    if (this.state.dataType === 'Live') {
    //  console.log("cmdty change :: this.state.liveCategory ::"+this.state.liveCategory);
      this.handleLiveCategoryOptionVal(this.state.showPrice,cmdtyKey,text, this.state.dataType)
      // if (this.state.liveCategory === 'Bid' && this.state.liveGraphType === 'Line') {
      //   this.lineChartDataAPICallStateWrapper(1, cmdtyKey, this.state.liveDuration, this.state.liveGraphType);
      // } else if (this.state.liveCategory === 'Ask' && this.state.liveGraphType === 'Line') {
      //   this.lineChartDataAPICallStateWrapper(0, cmdtyKey, this.state.liveDuration, this.state.liveGraphType);
      // } else {
      //   if(this.state.liveGraphType === 'Candle Stick'){
      //     this.lineChartDataAPICallStateWrapper(0, cmdtyKey, this.state.liveDuration, this.state.liveGraphType);
      //   }
      //   else {
      //     this.lineChartDataAPICallStateWrapper(2, cmdtyKey, this.state.liveDuration, this.state.liveGraphType);
      //   }
      // }
      this.setState(prevState => ({ data: [], pointsSinceLastAppend: [], pointsSinceLastAppendCandle: [], dataCandle: [], chartDataFormatted: false, CmdtPair: cmdtyKey, CmdtPairId: newCmdtyPair }));
      this.zoomLevel = undefined;
    } else if (this.state.dataType === 'Historical') {
        this.historicalChartDataAPICallStateWrapper(text, cmdtyKey, this.state.historicalStartDate, this.state.historicalEndDate, this.state.uniqueId);
        this.setState({ CmdtPair: cmdtyKey, historicalData: [], historicalDataFormatted: false, CmdtPairId: newCmdtyPair});
        this.zoomLevel = undefined;
      } else if (this.state.dataType === 'Historical') {
          this.historicalChartDataAPICallStateWrapper(text, cmdtyKey, this.state.historicalStartDate, this.state.historicalEndDate, this.state.uniqueId);
          this.setState(prevState => ({ CmdtPair: cmdtyKey, historicalData: [], historicalDataFormatted: false, CmdtPairId: newCmdtyPair}));
          this.zoomLevel = undefined;
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'CmdtPairChangeEvent', component:"ChartComponent"});
    }
  }

  dataTypeChangeEvent = (key, value) => {
    try{
      let template=[{'dataType':value,'graphType':this.state.liveGraphType,
                    'category':this.state.liveCategory,'duration':this.state.liveDuration,
                    'histGraphType':this.state.historicalGraphType}];
      this.props.changeChartCmdyPair(this.state.CmdtPairId,this.props.keyValue,this.props.layout,template);
      this.props.layoutChanged(1);
      //this.setState({msg:'Loading...'});
      this.setState({histMsg:'loading'});
      let newDataType = value;
      // Live or Historical
      if (newDataType === 'Historical') {
        this.setState({currentDate: getSelectedDate('last7Days')});
        this.historicalChartDataAPICallStateWrapper(this.state.CmdtPairId, this.state.CmdtPair, this.state.historicalStartDate, this.state.historicalEndDate, this.state.uniqueId);
        this.setState(prevState => ({ dataTypeKey:key, dataType: newDataType, historicalData: [], historicalDataFormatted: false, data: [], dataCandle: [], pointsSinceLastAppend: [], pointsSinceLastAppendCandle: [], chartDataFormatted: false }));
        this.zoomLevel = undefined;
      } else if (newDataType === 'Live') {
        this.handleLiveCategoryOptionVal(this.state.showPrice,this.state.CmdtPair,this.state.CmdtPairId, newDataType)
        //this.lineChartDataAPICallStateWrapper(0, this.state.CmdtPair, this.state.liveDuration, this.state.liveGraphType);
        this.setState(prevState => ({ dataTypeKey:key, dataType: newDataType, data: [], pointsSinceLastAppend: [], pointsSinceLastAppendCandle: [], dataCandle: [], chartDataFormatted: false, historicalData: [], historicalDataFormatted: false }));
        this.zoomLevel = undefined;
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'dataTypeChangeEvent', component:"ChartComponent"});
    }
  }

  historicalGraphTypeChangeEvent = (key, value) => {
    try{
      // historical graph type change
      let template=[{'dataType':this.state.dataType,'graphType':this.state.liveGraphType,
                    'category':this.state.liveCategory,'duration':this.state.liveDuration,
                    'histGraphType':value}];
      this.props.changeChartCmdyPair(this.state.CmdtPairId,this.props.keyValue,this.props.layout,template);
      this.props.layoutChanged(1);
      let newHistoricalGraphType = value;
      this.setState(prevState => ({  historicalGraphTypeKey:key, historicalGraphType: newHistoricalGraphType }));
      this.zoomLevel = undefined;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'historicalGraphTypeChangeEvent', component:"ChartComponent"});
    }
  }

  liveCategoryChangeEvent = (key, value,title) => {
    try{
      let template=[{'dataType':this.state.dataType,'graphType':this.state.liveGraphType,
                    'category':value,'duration':this.state.liveDuration,
                    'histGraphType':this.state.historicalGraphType}];
      this.props.changeChartCmdyPair(this.state.CmdtPairId,this.props.keyValue,this.props.layout,template);
      this.props.layoutChanged(1);
      //this.setState({msg: 'Loading...'});
      let newLiveCategoryChange = value;
      // toggle betwwen ask, bid or both
      if (newLiveCategoryChange === 'Bid') {
        typeSelected = 'B';
        this.lineChartDataAPICallStateWrapper(1, this.state.CmdtPairId, this.state.CmdtPair, this.state.liveDuration, this.state.liveGraphType);
      } else if (newLiveCategoryChange === 'Ask') {
        typeSelected = 'A';
        this.lineChartDataAPICallStateWrapper(0, this.state.CmdtPairId, this.state.CmdtPair, this.state.liveDuration, this.state.liveGraphType);
      } else {
        if(this.state.liveGraphType === 'Candle Stick'){
          this.lineChartDataAPICallStateWrapper(0, this.state.CmdtPairId, this.state.CmdtPair, this.state.liveDuration, this.state.liveGraphType);
        }
        else {
          this.lineChartDataAPICallStateWrapper(2, this.state.CmdtPairId, this.state.CmdtPair, this.state.liveDuration, this.state.liveGraphType);
        }
      }
      this.setState(prevState => ({ liveCategoryKey:key, liveCategory: newLiveCategoryChange, data: [], pointsSinceLastAppend: [], pointsSinceLastAppendCandle: [], dataCandle: [], chartDataFormatted: false,liveCategoryBuySellKey:title }));
      this.zoomLevel = undefined;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'liveCategoryChangeEvent', component:"ChartComponent"});
    }
  }

  liveDurationChangeEvent = (key, value) => {
    try{
      let template=[{'dataType':this.state.dataType,'graphType':this.state.liveGraphType,
                    'category':this.state.liveCategory,'duration':value,
                    'histGraphType':this.state.historicalGraphType}];
      this.props.changeChartCmdyPair(this.state.CmdtPairId,this.props.keyValue,this.props.layout,template);
      this.props.layoutChanged(1);
      //this.setState({msg: 'Loading...'});
      let newLiveDuration = value;
      let currTime = new Date().valueOf();
      if (value === 'Hour') {
        this.setState({timeSet:new Date().getMinutes()});
        this.setState({lineZoomSet:currTime - 20000000});
        setInterval(this.setTime.bind(this), 30000);
      }
      // toggle between tick, miute, or hour
      if (this.state.liveCategory === 'Bid') {
        this.lineChartDataAPICallStateWrapper(1, this.state.CmdtPairId, this.state.CmdtPair, newLiveDuration, this.state.liveGraphType);
      } else if (this.state.liveCategory === 'Ask') {
        this.lineChartDataAPICallStateWrapper(0, this.state.CmdtPairId, this.state.CmdtPair, newLiveDuration, this.state.liveGraphType);
      } else {
        if(this.state.liveGraphType === "Candle Stick"){
          this.lineChartDataAPICallStateWrapper(0, this.state.CmdtPairId, this.state.CmdtPair, newLiveDuration, this.state.liveGraphType);
        }
        else {
          this.lineChartDataAPICallStateWrapper(2, this.state.CmdtPairId, this.state.CmdtPair, newLiveDuration, this.state.liveGraphType);
        }
      }
      this.zoomLevel = undefined;
      let intervalValue = '';
      let candleintervalValue = 30000;
      if(this.state.liveGraphType === 'Line') {
        switch(newLiveDuration) {
          case 'Tick':
            // 1 sec
            intervalValue = 0;
            break;
          case 'Minute':
            // 15 secs
            intervalValue = 0;
            break;
          case 'Hour':
            // 1.5 minutes
            intervalValue = 0;
            break;
          default:
            intervalValue = 0;
        }
      }
      this.setState(prevState => ({ liveDurationKey:key, liveDuration: newLiveDuration, liveDurationIntervalValue: intervalValue, liveCandleDurationInterval: candleintervalValue, data: [], pointsSinceLastAppend: [], pointsSinceLastAppendCandle: [], dataCandle: [], chartDataFormatted: false }));
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'liveDurationChangeEvent', component:"ChartComponent"});
    }
  }

  liveGraphTypeOptionsChangeEvent =  (key, value) => {
    try{
      let template=[{'dataType':this.state.dataType,'graphType':value,
                    'category':'Ask','duration':'Minute',
                    'histGraphType':this.state.historicalGraphType}];
      this.props.changeChartCmdyPair(this.state.CmdtPairId,this.props.keyValue,this.props.layout,template);
      this.props.layoutChanged(1);
      //this.setState({msg: 'Loading...'});
      let liveGraphType = value;
      let liveduration = this.state.liveDuration;
      if(liveGraphType ==='Candle Stick') {
        liveduration = 'Minute';
        this.setState({liveDuration:'Minute'});
        // this.setState({liveCategory:'Ask'});
        // this.setState({liveCategoryBuySellKey:"buy"});
        this.handleLiveCategoryOptionVal(this.state.showPrice,this.state.CmdtPair,this.state.CmdtPairId, this.state.dataType);
        this.setState({timeFlag: 0});
        this.setState({liveCandleDurationInterval:30000, pointsSinceLastAppendCandle: [], chartDataFormatted: false});
      }
      else {
        this.setState({liveDurationIntervalValue:0});
        this.setState({ data: [], pointsSinceLastAppend: [], chartDataFormatted: false});
      }
      this.zoomLevel = undefined;
      this.lineChartDataAPICallStateWrapper(0, this.state.CmdtPairId, this.state.CmdtPair, liveduration , liveGraphType);
      this.setState({liveGraphTypeKey:key, liveGraphType:liveGraphType , chartDataFormatted: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'liveGraphTypeOptionsChangeEvent', component:"ChartComponent"});
    }
  }

  fetchHistoricalData = () => {
    try{
      // API
      this.setState(prevState => ({ historicalData: [], historicalDataFormatted: false }));
      this.historicalChartDataAPICallStateWrapper(this.state.CmdtPairId, this.state.CmdtPair, this.state.historicalStartDate, this.state.historicalEndDate, this.state.uniqueId);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'fetchHistoricalData', component:"ChartComponent"});
    }
  }

  lineChartDataAPICallStateWrapper(liveCategoryOption, cmdtyId, cmdtyPair, durationType, liveGraphType) {
    try{
      // console.log("liveCategoryOption:"+liveCategoryOption);
      // console.log("cmdtyId:"+cmdtyId);
      // console.log("cmdtyPair:"+cmdtyPair);
      // console.log("durationType:"+durationType);
      // console.log("liveGraphType:"+liveGraphType);
      this.setState({liveCategoryVal:liveCategoryOption,durationSelected: durationType});
      this.setState({msg:'loading'});
      //let cmdtyId = cmdtyPair.split('-')[0] + cmdtyPair.split('-')[1],
      let queryParamString = cmdtyId + liveCategoryOption + durationType;
      this.setState(prevState => ({ lastLiveAPIQueryParams: queryParamString }));
      if(liveGraphType === 'Candle Stick') {
        // console.log("inside candleStick");
        this.props.candleChartData(liveCategoryOption, cmdtyId, queryParamString, this.state.uniqueId, this.props.DFA.C);
      }
      else {
        this.props.lineChartData(liveCategoryOption, cmdtyId, queryParamString, this.state.uniqueId, this.props.DFA.C);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'lineChartDataAPICallStateWrapper', component:"ChartComponent"});
    }
  }

historicalChartDataAPICallStateWrapper(cmdtyId, cmdtyPair, startDateMomentObject, endDateMomentObject) {
  try{
    // let cmdtyPairFormattedString = cmdtyPair.split('-')[0] + cmdtyPair.split('-')[1];
    let cmdtyPairFormattedString = cmdtyId;
    let formattedStartDate = moment(startDateMomentObject).format('YYYY/MM/DD');
    let formattedEndDate = moment(endDateMomentObject).format('YYYY/MM/DD');
    this.setState({histMsg:'loading'});
    let queryParamString = cmdtyPairFormattedString + formattedStartDate + formattedEndDate;
    this.setState(prevState => ({ lastHistoricalAPIQueryParams: queryParamString }));
    this.historicalChartDataAPICall(cmdtyPairFormattedString, formattedStartDate, formattedEndDate, queryParamString, this.state.uniqueId);
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'historicalChartDataAPICallStateWrapper', component:"ChartComponent"});
  }
}

  historicalChartDataAPICall(cmdtyPairFormattedString, formattedStartDate, formattedEndDate, queryParamString, uniqueId) {
    try{
      this.props.historicalChartData(cmdtyPairFormattedString, formattedStartDate, formattedEndDate, queryParamString, uniqueId);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'historicalChartDataAPICall', component:"ChartComponent"});
    }
  }

  closeWidget = (keyValue) => {
    try{
      this.setState({ clickedRemove: true });
      this.props.deleteWidget(keyValue);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeWidget', component:"ChartComponent"});
    }
  }
  
  setTime() {
    try{
      this.setState({lineZoomSet: new Date().valueOf() - 20000000});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setTime', component:"ChartComponent"});
    }
  }

  updateZoomLevel = (zoomLevel) => {
    try{
      this.zoomLevel = zoomLevel;
      // this.setState({ zoomLevel });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'updateZoomLevel', component:"ChartComponent"});
    }
  }

  closeModal = (event) => {
    try{
      this.setState({popupflag: false});
      let splitCurrDate= this.state.currentDate.toString().split('-');
      this.setState({
              currentDate:new Date(splitCurrDate[0]).toLocaleDateString('en-US') + ' - ' +
              new Date(splitCurrDate[1]).toLocaleDateString('en-US')});
      this.props.onClickCalender(true,this.props.keyValue);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeModal', component:"ChartComponent"});
    }
  }

  setSidebar = () => {
    try{
      this.setState({menusOpen: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setSidebar', component:"ChartComponent"});
    }
  }

  openMenus = () => {
    try{
      if(this.state.menusOpen==true){
        this.setState({menusOpen: false});
      }else{
        this.setState({menusOpen: true});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'openMenus', component:"ChartComponent"});
    }
  }
  
  gridType = () => {
    try{
      this.setState({showGridOptions: !this.state.showGridOptions});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'gridType', component:"ChartComponent"});
    }
  }

  closeGridType = () => {
    try{
      this.setState({showGridOptions: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeGridType', component:"ChartComponent"});
    }
  }

  onClick = (e, data) => {
    try{
      if((data.rowNumber==0 && data.columnNumber<=4)||(data.rowNumber<=4 && data.columnNumber==0)){
        this.props.resizeChart(2,2,this.props.keyValue);
      }else{
        this.props.resizeChart(data.rowNumber+1,data.columnNumber+1,this.props.keyValue);
        this.setState({showGridOptions: false});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClick', component:"ChartComponent"});
    }
  }
  setStartDate = startDate => {
    try{
      this.setState({ historicalStartDate:startDate});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setStartDate', component:"ChartComponent"});
    }
  }

  setEndDate = endDate => {
    try{
      this.setState({ historicalEndDate:endDate });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setEndDate', component:"ChartComponent"});
    }
  }

  applyDate = () => {
    try {
        this.fetchHistoricalData();
        this.zoomLevel = undefined;
    } catch(e) {
      this.props.logFileCreation({error:e.message, originFunction:'applyDate', component:"ChartComponent"});
    }
  }

  onCancelDate=()=>{
    try{
      let splitCurrDate= this.state.currentDate.toString().split('-');
      this.setState({
              currentDate:new Date(splitCurrDate[0]).toLocaleDateString('en-US') + ' - ' +
                new Date(splitCurrDate[1]).toLocaleDateString('en-US')});
      this.setState({openCalender:false});
      this.props.onClickCalender(false,this.props.keyValue);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onCancelDate', component:"ChartComponent"});
    }
  }

  closeValidationModal=()=>{
    try{
      this.props.onClickCalender(true,this.props.keyValue);
      this.setState({validationFlag :false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeValidationModal', component:"ChartComponent"});
    }
  }

  handleLiveCategoryOptionVal(showPrice,cmdtyPair,cmdtyId,dataType){
    try{
      let liveCategoryValue, liveCategoryKey, liveCategory ;
      if (this.props.userDetail.ShowBuySellInRates === true ) {
        if (showPrice === 'ASK' || showPrice === 'BOTH') {
          liveCategoryValue = 'buy';
          liveCategoryKey = 'ask';
          liveCategory = 'Ask' ;
        }else if (showPrice === 'BID') {
          liveCategoryValue = 'sell';
          liveCategoryKey = 'bid';
          liveCategory = 'Bid' ;
        }
      }else {
        if (showPrice === 'ASK' || showPrice === 'BOTH') {
          liveCategoryValue = 'Ask';
          liveCategoryKey = 'ask';
          liveCategory = 'Ask' ;
        }else if (showPrice === 'BID') {
          liveCategoryValue = 'Bid';
          liveCategoryKey = 'bid';
          liveCategory = 'Bid' ;
        }
      }
      // console.log("liveCategoryValue::"+liveCategoryValue);
      // console.log("liveCategoryKey::"+liveCategoryKey);
      this.setState({
        liveCategoryBuySellKey:liveCategoryValue,
        liveCategoryKey:liveCategoryKey,
        liveCategory:liveCategoryKey === 'ask' ? 'Ask' : 'Bid',
        liveCategoryOptions:this.props.userDetail.ShowBuySellInRates === true ? this.state.liveCategoryOptionsSellBuy:this.state.liveCategoryOptionsBidAsk
      });
      let key = liveCategoryKey === 'ask' ? 1 : 0 ;
      if(dataType ==='Live'){
        this.setState({dataTypeKey: 'live'});
        // console.log("this.state.liveGraphType::::::::"+this.state.liveGraphType);;
        if (liveCategory === 'Bid') {
          this.lineChartDataAPICallStateWrapper(1, cmdtyId, cmdtyPair, this.state.liveDuration, this.state.liveGraphType);
        } else if (liveCategory === 'Ask') {
          this.lineChartDataAPICallStateWrapper(0, cmdtyId, cmdtyPair, this.state.liveDuration, this.state.liveGraphType);
        } else {
          if(this.state.liveGraphType === 'Candle Stick'){
            this.lineChartDataAPICallStateWrapper(0, cmdtyId ,cmdtyPair, this.state.liveDuration, this.state.liveGraphType);
          }
          else {
            this.lineChartDataAPICallStateWrapper(2, cmdtyId, cmdtyPair, this.state.liveDuration, this.state.liveGraphType);
          }
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleLiveCategoryOptionVal', component:"ChartComponent"});
    }
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      // //const allCssStyleRules = this.props.selectedCssColorTheme;
      //  const elementsData = [
      //    {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //    {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //    {"classNames":"mdlWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //    {"classNames":"Loading","elementType":"normal", "applyTo":"single", "tagNames":"div"}
      //  ];
      //  applyStyle(thisComponent, allCssStyleRules, elementsData);
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
          {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"}
          //{"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"}
      ];
      // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"ChartComponent"});
    }
  }
  render() {
    // const start = this.state.historicalStartDate.format('DD-MM-YYYY');
    // const end = this.state.historicalEndDate.format('DD-MM-YYYY');
    // let label = start + ' - ' + end;
    // if (start === end) {
    //   label = start;
    // }
    const selectedThemes = themes[this.props.userDetail.selectedTheme];

    const { CloseIcon, keyValue } = this.props;
    const { dataTypeKey, liveGraphTypeKey, historicalGraphTypeKey, liveDurationKey, clickedRemove, CmdtPair, lineZoomSet, CmdtPairId, cmdtPairOptions, dataType, dataTypeOptions, liveCategory, liveCategoryOptions, liveDuration, liveDurationOptions, historicalGraphType, historicalGraphTypeOptions, historicalDuration, historicalDurationOptions, historicalStartDate, historicalEndDate, data, pointsSinceLastAppendCandle, dataCandle, data2, historicalData, decimals, liveGraphType, liveGraphTypeOptions, pointsSinceLastAppend, liveCategoryBuySellKey } = this.state;
    let updateTime = lineZoomSet;
    
    const selectedfont_size ="fontSize_"+this.props.userDetail.fontSize;
    const drop_menus = <div className={`${styles.chartDropdownMenu} ${this.props.selectedCssColor}`} style={this.props.selectedLang.chartDropdownMenu} id="chrtDropdownDiv">
      <a href="javascript:void(0)" onClick={() => this.openMenus()} id="chrtDropdownHref">
        <div className={styles.showChartDropdownMenu} ></div>
        <div className={styles.showChartDropdownMenu}></div>
        <div className={styles.showChartDropdownMenu} ></div>
      </a>
      <div className={`${styles.chartDropdownMenuList} chartDropdownMenuList`}
        style={this.state.menusOpen ==true ?
          (this.props.language !== 'AR' ? 
          Object.assign({
            transform: `translate3d(-0.6rem, 0, 0)`},
             this.props.selectedLang.chartDropdownMenuList): 
             Object.assign({transform: `translate3d(-110%, 0, 0)`},
             this.props.selectedLang.chartDropdownMenuList)):
          this.props.language !== 'AR' ? Object.assign({transform: `translate3d(-110%, 0, 0)`},
          this.props.selectedLang.chartDropdownMenuList): 
          Object.assign({transform: `translate3d(-0.6rem, 0, 0)`},
          this.props.selectedLang.chartDropdownMenuList)}>

          <div className={`${styles.wrapper2} wrapper2`} id='cmdtPairOptions'>
          <label className={`${selectedfont_size} ${styles.labelAlign}`}>{i18next.t('cmdtyPair')}</label>
          <DcoDropdown
            dropdownTitle={this.state.CmdtPair}
            dropdownId="bg-nested-dropdown"
            dropdownData={this.state.cmdtPairOptions}
            dataItemClick={this.CmdtPairChangeEvent}
            dropdownClassname={`${selectedfont_size} chrtDropdown`}
            menuClassname={`${selectedfont_size}`}
            //dropdown
            //menu
            hoverStyle={this.props.selectedCssColor}
          />
          </div>
          {/*<div className={styles.wrapper2} id='cmdtPairOptions'>
            <label className={`${selectedfont_size} ${styles.labelAlign}`}>{i18next.t('Cmdty Pair')}</label>
            <DropdownButton className={`${selectedfont_size} roundBorder`} title={this.state.CmdtPair} id="bg-nested-dropdown">
              {(this.state.cmdtPairOptions).map((item) => {
                return (
                  <MenuItem onClick={() => this.CmdtPairChangeEvent(item.value, item.id)} className={`${selectedfont_size}`} id="chtCmdtyMenu">{item.value}</MenuItem>
                  );
                })
              }
            </DropdownButton>
          </div>*/}
          <div className={`${styles.wrapper2} wrapper2`} id='dataTypeOptions'>
            <label className={`${selectedfont_size} ${styles.labelAlign}`}>{i18next.t('dataType')}</label>
            <DropdownButton title={i18next.t(dataTypeKey)} id="bg-nested-dropdown" className={`${selectedfont_size} chrtDropdown`}>
              {dataTypeOptions.map((item) => {
                return (
                  <MenuItem onClick={() => this.dataTypeChangeEvent(item.key, item.value)} className={`${selectedfont_size}`} id="chtDataTypeMenu">{i18next.t(item.key)}</MenuItem>
                );
              })
            }
            </DropdownButton>
          </div>
          {
            dataType==='Live' &&
            <div className={`${styles.wrapper2} wrapper2`} id="liveGraphTypeOption">
            <label className={`${selectedfont_size} ${styles.labelAlign}`}>{i18next.t('graphType')}</label>
            <DropdownButton title={i18next.t(liveGraphTypeKey)} id="bg-nested-dropdown" className={`${selectedfont_size} chrtDropdown`}>
              {
                liveGraphTypeOptions.map((item) => {
                  return (
                    <MenuItem onClick={() => this.liveGraphTypeOptionsChangeEvent(item.key, item.value)} className={`${selectedfont_size}`} id="chtLiveDataMenu">{i18next.t(item.key)}</MenuItem>
                  );
                })
              }
            </DropdownButton>
            </div>
          }
          {
            dataType==='Live' && liveGraphType==='Line' &&
            <div className={`${styles.wrapper2} wrapper2`} id='liveCategoryOptions'>
            <label className={`${selectedfont_size} ${styles.labelAlign}`}>{i18next.t('category')}</label>
            <DropdownButton title={i18next.t(liveCategoryBuySellKey)} id="bg-nested-dropdown" className={`${selectedfont_size} chrtDropdown`}>
              {
                liveCategoryOptions.map((item) => {
                  return (
                    ((this.props.userDetail.showPrice==="BID"  && item.key==="ask" || item.key==="both") || (this.props.userDetail.showPrice==="ASK"  && item.key==="bid" || item.key==="both")) && this.props.userDetail.showPrice !== "BOTH" ?
                    null:
                    <MenuItem onClick={() => this.liveCategoryChangeEvent(item.key, item.value,item.title)} className={`${selectedfont_size}`} id="chtLiveCatMenu">{i18next.t(item.title)}</MenuItem>
                  );
                })
              }
            </DropdownButton>
            </div>
          }
          {dataType==='Live' && liveGraphType==='Line' &&
            <div className={`${styles.wrapper2} wrapper2`} id='liveDurationOptions'>
            <label className={`${selectedfont_size} ${styles.labelAlign}`} >{i18next.t('durationType')}</label>
              <DropdownButton title={i18next.t(liveDurationKey)} id="bg-nested-dropdown" className={`${selectedfont_size} chrtDropdown`} >
                {liveDurationOptions.map((item) => {
                  return (
                    <MenuItem onClick={() => this.liveDurationChangeEvent(item.key, item.value)} className={`${selectedfont_size}`}   id="chtLiveDurationMenu">{i18next.t(item.key)}</MenuItem>
                  );
                })
              }
              </DropdownButton>
            </div>
          }
          {dataType==='Historical' &&
            <div className={`${styles.wrapper2} wrapper2`} id='historicalGraphTypeOptions'>
            <label className={`${selectedfont_size} ${styles.labelAlign}`} >{i18next.t('graphType')}</label>
              <DropdownButton title={i18next.t(historicalGraphTypeKey)} id="bg-nested-dropdown" className={`${selectedfont_size}`} >
                {historicalGraphTypeOptions.map((item) => {
                  return (
                    <MenuItem onClick={() => this.historicalGraphTypeChangeEvent(item.key, item.value)} className={`${selectedfont_size}`} id="chtHistoGraphMenu" >{i18next.t(item.key)}</MenuItem>
                  );
                })
              }
              </DropdownButton>
            </div>
          }
          {dataType==='Historical' &&
          <div className={`${styles.row_Content}`} id="chartDatePicker">
          <label className={`${selectedfont_size} ${styles.labelAlign}`} >{i18next.t('dateRange')}</label>
            {/*<DateRangePicker maxDate={moment().subtract(0, 'days')} ranges={rangeSelect} startDate={this.state.historicalStartDate} endDate={this.state.historicalEndDate} onApply={this.handleDateRange} locale={locale} className={`${selectedfont_size}`} id="chtHistoDatePicker">
              <button type="button" className={`${selectedfont_size} selected-date-range-btn btn btn-default   chrtDropdown`}>
                <div className="pull-left">
                  <span className="glyphicon glyphicon-calendar"></span>
                </div>
                <div>
                  <span className={styles.labeldate}>
                    {label}
                  </span>
                  <span className={styles.caret}></span>
                </div>
              </button>
            </DateRangePicker>*/}
            <div >
                <DateSelector
                    setStartDate={this.setStartDate}
                    setEndDate={this.setEndDate}
                    onClickFilter={this.applyDate}
                    startDate={this.state.historicalStartDate}
                    endDate={this.state.historicalEndDate}
                    component='Chart'
                    keyValue={this.props.keyValue}
                />
            </div>
          </div>
        }
      </div>
    </div>
    return (
      <div className={styles.chart}>
        {!clickedRemove? <div className="widgetwrapper chartwidgetwrapper">
          <Modal isOpen={this.state.validationFlag} className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.header} header`}>
                <span className={`${styles.msgTitle} widgettitle`}>{i18next.t("error")}</span>
              </div>
              <span onClick={this.closeValidationModal} className={`${styles.closeImg} closeIcon`} id="chtCloseIcon"><MUIIcon icon={'Close'} className="closeBtn"/></span>
              <div className={`${styles.msg} msgTitle`}>
                <h4>{i18next.t("dateSelectorErrMsg")}</h4>
              </div>
            </div>
          </Modal>
            <div className='headerInner'>
              <div className='widgetheader'>
                <span className={`${selectedfont_size} widgettitle`}>{i18next.t('graph')}: {CmdtPair}</span>
                {/* <span className={isPopOutDisabled=== false ? `popupicon` : `${styles.disabled} popupicon`} onClick={() => this.popoutWidget(keyValue)}>
                  <img src="/images/popout.png"/>
                </span> */}
                <span onClick={() => this.gridType()}  className="vericalDotIcon" ></span>
                {/* this.state.showGridOptions === true ?
                <div className={`${selectedfont_size} gridOptions`}>
                  <div className={`gridOptionsWrapper`}>
                    <span>{i18next.t("Resize")}</span>
                  </div>
                </div> : null
                */}
                <div className={`resizeLayout`}>
                  <HoverTable
                    column={5}
                    row={5}
                    width={110}
                    height={110}
                    selectedRow={this.props.height-1}
                    selectedColumn={this.props.width-1}
                    onClick={this.onClick}
                    showDimension={true} // show dimension or not
                    onMouseOut={this.onMouseOut}
                    onMouseOver={this.onMouseOver}
                    theme="light"
                    defaultColumn={1}
                    defaultRow={1}
                  />
                </div>
                <span onClick={() => this.closeWidget(keyValue)} id="chtCloseIcon">
                  {CloseIcon}
                </span>
              </div>
            </div>
              <div ref="chartBody" className={`${styles.chartBody} chartBody`} id="chart" onClick={() => this.closeGridType()}>
                { (dataType==='Live' && data && data.length>10 && liveGraphType === "Line" && liveCategory !== "Both") &&
                  <div className={`${this.props.language}`}>
                  {drop_menus}
                  <div onClick={() => this.setSidebar()} id="chartliveline">
                  <div className={`${styles.timehead1}`}>
                  </div>
                  <Chart  key={keyValue} zoomSet={updateTime} decimals={decimals} type={"svg"} data={data} durationType={liveDuration} liveCategory={liveCategory} width={(this.refs.chartBody.clientWidth) - 20} height={this.refs.chartBody.clientHeight} onZoomEvent={this.updateZoomLevel} zoomLevel={this.zoomLevel} id="chtChartBody" selectedThemes={selectedThemes}/>
                  </div>
                  </div>
                }
                {
                  ((dataType==='Live' && dataCandle && dataCandle.length>1 && liveGraphType === "Candle Stick")) &&
                  <div className={`${this.props.language}`}>
                  {drop_menus}
                  <div onClick={() => this.setSidebar()} id="chartlivecandle">
                  <div className={`${styles.timehead}`} >
                  </div>
                  <CandleStickChart key={keyValue} nextData={data2} timeInterval={utcMinute} decimals={decimals} type={"svg"} data={dataCandle} durationType={liveDuration} liveCategory={liveCategory} width={(this.refs.chartBody.clientWidth) - 20} height={this.refs.chartBody.clientHeight} onZoomEvent={this.updateZoomLevel} zoomLevel={this.zoomLevel} displayTexts={{
                    d: "time",
                    o: "O",
                    h: "H",
                    l: "L",
                    c: "C",
                    v: "V",
                    na: "n/a"
                  }} id="chtCandleStickChart" selectedThemes={selectedThemes}/>
                  </div>
                  </div>
                }
                { (dataType==='Live' && liveGraphType === "Line" && data && data.length>10 && liveCategory === "Both") &&
                  <div className={`${this.props.language}`}>
                  {drop_menus}
                  <div onClick={() => this.setSidebar()} id="chartlivemulti">
                    <div className={`${styles.timehead1}`} >
                    </div>
                  <MultiChart  key={keyValue} zoomSet={updateTime} decimals={decimals} type={"svg"} data={data} durationType={liveDuration} liveCategory={liveCategory} width={(this.refs.chartBody.clientWidth) - 20} height={this.refs.chartBody.clientHeight} onZoomEvent={this.updateZoomLevel} zoomLevel={this.zoomLevel} id="chtMultiChart" selectedThemes={selectedThemes}/>
                  </div>
                  </div>
                }
                { (dataType==='Live' && liveGraphType === "Line" && (data.length <= 10)) &&
                  <div className={`${this.props.language}`}>
                  {drop_menus}
                  <div onClick={() => this.setSidebar()} id="chartlineNodata">
                  <div className={`${styles.timehead1}`} >
                  </div>
                  <div className={`${styles.chartLoading} chartLoading`}  >{i18next.t(this.state.msg)}</div>
                  </div>
                  </div>
                }
                { (dataType==='Live' && liveGraphType === "Candle Stick" && dataCandle.length <= 1) &&
                <div className={`${this.props.language}`}>
                {drop_menus}
                <div onClick={() => this.setSidebar()} id="chartCandleNodata">
                <div className={`${styles.timehead1}`} >
                </div>
                  <div className={`${styles.chartLoading} chartLoading`}  >{i18next.t(this.state.msg)}</div>
                </div>
                </div>
                }
                { (dataType==='Historical' && historicalData && historicalData.length>1 && historicalGraphType==='Line') &&
                  <div className={`${this.props.language}`}>
                  {drop_menus}
                  <div onClick={() => this.setSidebar()} id="chartHistoricalLine">
                  <div className={`${styles.timehead1}`} >
                  </div>
                  <HistoricalLineChart  key={keyValue} decimals={decimals} type={"svg"} data={historicalData} durationType={historicalDuration} width={(this.refs.chartBody.clientWidth) - 20} height={this.refs.chartBody.clientHeight} onZoomEvent={this.updateZoomLevel} zoomLevel={this.zoomLevel} id="chtHistChart" selectedThemes={selectedThemes}/>
                  </div>
                  </div>
                }
                { (dataType==='Historical' && historicalData && historicalData.length>1 && historicalGraphType==='OHLC') &&
                  <div className={`${this.props.language}`}>
                  {drop_menus}
                  <div onClick={() => this.setSidebar()} id="chartHistoricalOhlc">
                  <div className={`${styles.timehead1}`} >
                  </div>
                  <OHLC  key={keyValue} type={'svg'} decimals={decimals} data={historicalData} width={(this.refs.chartBody.clientWidth) - 20} height={this.refs.chartBody.clientHeight} onZoomEvent={this.updateZoomLevel} zoomLevel={this.zoomLevel} id="chtOHLCChart" selectedThemes={selectedThemes}/>
                  </div>
                  </div>
                }
                { (dataType==='Historical' && historicalData  && historicalData.length>1 && historicalGraphType==='Candle Stick') &&
                  <div className={`${this.props.language}`}>
                  {drop_menus}
                  <div onClick={() => this.setSidebar()} id="chartHistoricalCandle">
                  <div className={`${styles.timehead1}`} >
                  </div>
                  <HistoricalCandleChart  data={historicalData} key={keyValue} type={'svg'} decimals={decimals} width={(this.refs.chartBody.clientWidth) - 20} height={this.refs.chartBody.clientHeight} onZoomEvent={this.updateZoomLevel} zoomLevel={this.zoomLevel} timeInterval={utcDay} id="chtHistCandleChart" selectedThemes={selectedThemes}/>
                  </div>
                  </div>
                }
                { (dataType==='Historical' && historicalData && historicalData.length<2) &&
                  <div className={`${this.props.language}`}>
                  {drop_menus}
                  <div onClick={() => this.setSidebar()} id="chartHistoricalNodata">
                  <div className={`${styles.timehead1}`} >
                  </div>
                  <div className={`${styles.chartLoading} chartLoading`} >{i18next.t(this.state.histMsg)}</div>
                  </div>
                  </div>
                }
                { (dataType==='Historical' && this.state.popupflag === true) &&
                  <div>
                  <Modal isOpen={this.state.popupflag} className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
                    <div ref="errorMSG" className="mdlWrap" >
                      <div className={`${styles.header} header`}>
                        <span className={`${styles.msgTitle} widgettitle`}>{i18next.t("error")}</span>
                      </div>
                      <span onClick={this.closeModal} className={`${styles.closeImg} closeIcon`} id="chtCloseIcon"><MUIIcon icon={'Close'} className="closeBtn"/></span>
                      <div className={`${styles.msg} msgTitle`}>
                        <h4>{i18next.t("graphErrMsg")}</h4>
                      </div>
                    </div>
                  </Modal>
                  </div>
                }
              </div>
         </div>: null}
      </div>
    );
  }
}
